export default __webpack_public_path__ + "85c3091326096406578bd590d55721b2.wav";